/*
 * @Author: chenliang
 * @Date: 2021-02-02 16:29:03
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-02 16:37:01
 * @Description: tab列表
 */
import React, { Component } from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

export default class DataTab extends Component {
  static propTypes = {

  };

  onChange = (key) => {
    console.log(key);
  }

  render() {
    return (
      <div className="home-data-tab">
          <div className="title">
              职位列表
          </div>
        <Tabs defaultActiveKey="1" onChange={() => this.onChange()}>
            <TabPane tab="用户浏览职位" key="1">
            Content of Tab Pane 1
            </TabPane>
            <TabPane tab="用户收藏职位" key="2">
            Content of Tab Pane 2
            </TabPane>
            <TabPane tab="用户投递职位" key="3">
            Content of Tab Pane 3
            </TabPane>
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/DataTab.js